// eslint-disable-next-line no-unused-vars
import { decodeRSA } from './function';

let permissions;

export default permissions = {
  apply: ((service, response) => {
    switch (service) {
      case 'get_account_types':
        return permissions.users_type(response);
      case 'get_enterprises':
        return permissions.enterprises(response);
      case 'update_account':
      case 'delete_account':
        return permissions.modify_accounts(response);
      default:
        return response;
    }
  }),
  enterprises: ((enterprises) => {
    if (decodeRSA(sessionStorage.type) === '5') {
      // eslint-disable-next-line max-len
      return enterprises.filter(enterprise => enterprise.id.toString() === sessionStorage.enterprise);
    }
    return enterprises;
  }),
  users_type: ((types) => {
    switch (decodeRSA(sessionStorage.type)) {
      case '1':
        return types;
      case '2':
        return types.filter(users => users.id !== 1);
      case '3':
        return types.filter(users => users.id === 4 || users.id === 5);
      case '5':
        return types.filter(users => users.id === 4);
      default:
        return types.filter(users => users.id === 0);
    }
  }),
  modify_accounts: ((account) => {
    switch (decodeRSA(sessionStorage.type)) {
      case '1':
        return true;
      case '2':
        return account.account_types_id !== 1;
      case '3':
        return account.account_types_id === 4 || account.account_types_id === 5;
      case '5':
        return account.account_types_id === 4;
      default:
        return false;
    }
  }),
};
